import Input from "@ui-components/Input";
import { useState, useEffect } from "react";
import { WonWorkflowProps } from "./types";
import { useIntl } from "react-intl";
import { WonWorksiteSchema } from "../types";
import SearchSelect from "ui-components/SearchSelect";
import GetData from "./data";
import {MandatoryLabel} from "../../MandatoryLabel";

export const WonWorkflow = ({
  internalUser,
  setWonWorksiteData,
}: WonWorkflowProps) => {
  const intl = useIntl();
  const { channelOptions } = GetData(intl.formatMessage);

  const [wonChannel, setWonChannel] = useState<{
    value: string;
    label: string;
  }>();
  const [reason, setReason] = useState<string>();

  useEffect(() => {
    let data = {
      type: "won",
      channel: { type: wonChannel?.value, reason: reason },
    };

    if (wonChannel?.value == "GeniusLab" || !reason) {
      delete data.channel.reason;
    }
    setWonWorksiteData(data as WonWorksiteSchema);
  }, [wonChannel, reason]);

  return (
    <>
      <SearchSelect
        label={
          <MandatoryLabel
            label={intl.formatMessage({
              id: "terminate_reason_won_channel_label",
              defaultMessage: "Canale utilizzato",
            })}
            mandatory={!wonChannel}
          />
        }
        options={channelOptions}
        value={channelOptions.find((option) => option.value === wonChannel?.value) || null}
        isClearable
        onChange={(e) => setWonChannel(e)}
      />
      {(wonChannel?.value === "Other" || wonChannel?.value == "OtherKKChannel") && (
          <Input
            label={
              <MandatoryLabel
                label={wonChannel?.value == "Other"
                ? intl.formatMessage({
                    id: "terminate_reason_won_other_channel_reason",
                    defaultMessage: "Quale?",
                  })
                : intl.formatMessage({
                    id: "terminate_reason_won_other_channel_specific",
                    defaultMessage: "Specifica",
                  })}
                mandatory={internalUser}
              />}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            required={internalUser}
          />
        )}
    </>
  );
};
